import React from "react";
import "./Loading.scss";
import { LoadingIcon } from "../ui/icons";
import { B1 } from "../ui/Typography";

const Loading = ({ icon: Icon = LoadingIcon, title }) => {
  return (
    <div className="loading-wrapper">
      <div className="loading-box">
        <div className="borderWrapper w-100 h-100">
          <div className="borderInner h-100">
            <div className="loading-box-inner">
              <Icon className="loading-icon" />
              <B1 className="loading-message">{title}</B1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
